import React from 'react';

export default React.createContext({
  sectors: [],
  hours: [],
  proximity: [],
  apprenticeshipLevels: [],
  welshLanguage: [],
  disabilityConfident: []
});
